import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';
import {
    IContactOrGroupRequest,
    IMessageListRequest,
    IMessageRequest,
    IConversationListRequest,
} from '../models/pages/messages';

const token: any = localStorage.getItem('access_token');
const _logger = Log.create('Message-Service');
const T = Translator.create();
let _apiClient: ApiClient;

export class MessagesService {
    public modalRootDiv: HTMLElement | null = null;

    constructor() {
        _apiClient = new ApiClient();
    }

    // get message contacts
    public async RequestGetContactsAsync(request: IContactOrGroupRequest) {
        const queryString =
            'take=' + request.take + '&skip=' + request.skip + (request.keyword ? '&keyword=' + request.keyword : '');
        return _apiClient
            .RequestAsync('GET', 'api/message/contact?' + queryString, null, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    throw (new Error(responseData.status.toString()));
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                // TODO: resource dosyasına eklenecek
                Notification.setNotification('error', T.t('r_message_module_get_contacts_api_error'), 'topRight');
                return null;
            });
    }

    // get groups (classes)
    public async RequestGetGroupsAsync(request: IContactOrGroupRequest) {
        const queryString =
            'take=' + request.take + '&skip=' + request.skip + (request.keyword ? '&keyword=' + request.keyword : '');
        return _apiClient
            .RequestAsync('GET', 'api/message/group?' + queryString, null, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    throw (new Error(responseData.status.toString()));
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                // TODO: resource dosyasına eklenecek
                Notification.setNotification('error', T.t('r_message_module_get_groups_api_error'), 'topRight');
                return null;
            });
    }

    // Get Origin Message Id With a Contact
    public async RequestGetOriginMessageAsync(recipientId: string, recipientType: string = 'User') {
        return _apiClient
            .RequestAsync('GET', 'api/message/origin/' + recipientId + '?recipientType=' + recipientType, null, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200 && responseData.status !== 404) {
                    Notification.setNotification('error', T.t('r_message_module_get_origin_message'), 'topRight');
                    return null;
                } else if (responseData.status === 200) {
                    return responseData.json();
                }
                return [];
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                Notification.setNotification('error', T.t('r_message_module_get_origin_message'), 'topRight');
                return false;
            });
    }

    // Get Selected Announcement
    public async RequestGetMessagesAsync(request: IMessageListRequest) {
        if (request.originMessageId == null) {
            return [];
        }
        const queryString = 'take=' + request.take + '&skip=' + request.skip;
        return _apiClient
            .RequestAsync('GET', 'api/message/' + request.originMessageId + '?' + queryString, null, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification(
                        'error',
                        T.t('r_course_page_get_message_list_error_message'),
                        'topRight'
                    );
                    return [];
                } else {
                    this.RequestPostMessageReadStatusAsync(request.originMessageId, request.skip, request.take);
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                Notification.setNotification('error', T.t('r_course_page_get_message_list_error_message'), 'topRight');
                return false;
            });
    }

    public async RequestPostMessageReadStatusAsync(originMessageId: string, skip: number, take: number) {
        const queryString = 'take=' + take + '&skip=' + skip;
        return _apiClient
            .RequestAsync('POST', 'api/message/' + originMessageId + '/read?'+ queryString, null, token)
            .then((responseData: Response) => {
                if (responseData.status !== 204) {
                    Notification.setNotification(
                        'error',
                        T.t('r_course_page_get_message_list_error_message') + ' _read_status',
                        'topRight'
                    );
                }

                return true;
            })
            .then((result: any) => {
                return true;
            })
            .catch(response => {
                Notification.setNotification('error', T.t('r_course_page_get_message_list_error_message'), 'topRight');
                return false;
            });
    }

    public async RequestGetUnreadMessageCountAsync(params: any) {
        return _apiClient
            .RequestAsync(
                'GET',
                'api/message/unreadcount',
                null,
                token
            )
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestSendMessageAsync(request: IMessageRequest) {
        return _apiClient
            .RequestAsync('POST', 'api/message', request, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    return null;
                } else if (responseData.status === 200) {
                    return responseData.json();
                }
                return null;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return false;
            });
    }

    public async RequestDeleteMessageAsync(messageId: string, deleteType: number) {
        return _apiClient
            .RequestAsync('DELETE', 'api/message/' + messageId + '/' + deleteType, null, token)
            .then((responseData: Response) => {
                if (responseData.status !== 204) {
                    Notification.setNotification('error', T.t('r_message_module_delete_message'), 'topRight');
                    return null;
                }
                return messageId;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                Notification.setNotification('error', T.t('r_message_module_delete_message'), 'topRight');
                return false;
            });
    }

    public async RequestGetConversationsAsync(request: IConversationListRequest) {
        const queryString =
            'take=' +
            request.take +
            '&skip=' +
            request.skip +
            '&isGroup=' +
            request.isGroup +
            (request.keyword ? '&keyword=' + request.keyword : '');
        return _apiClient
            .RequestAsync('GET', 'api/message/conversation?' + queryString, null, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification(
                        'error',
                        T.t('r_message_module_get_conversations_api_error'),
                        'topRight'
                    );
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                Notification.setNotification('error', T.t('r_message_module_get_conversations_api_error'), 'topRight');
                return false;
            });
    }

    public async RequestGetHeaderMessagesAsync(request: IConversationListRequest) {
        const queryString =
            'take=' +
            request.take +
            '&skip=' +
            request.skip +
            '&isGroup=' +
            request.isGroup +
            (request.keyword ? '&keyword=' + request.keyword : '');
        return _apiClient
            .RequestAsync('GET', 'api/message/getunreadchatlist?' + queryString, null, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification(
                        'error',
                        T.t('r_message_module_get_conversations_api_error'),
                        'topRight'
                    );
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                Notification.setNotification('error', T.t('r_message_module_get_conversations_api_error'), 'topRight');
                return false;
            });
    }

    public async RequestGetConversations(params: any, isAll: boolean) {
        const queryString = 'take=' + params.Take + '&skip=' + params.Skip + '&isGroup=' + params.IsGroup + '&isAll=' + isAll + '&lastMessageId=' + params.lastMessageId;
        return _apiClient.RequestAsync('GET', 'api/message/conversation?' + queryString, null, token).then((response: Response) => {
            return response;
        }).catch((response: any) => {
            return response;
        });
    }

    public async RequestReadMessagesAsync() {
        const requestUrl = 'api/message/markasreadallchats';
        
        return _apiClient.RequestAsync('GET', requestUrl).then((responseData: any) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }
}
